<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25.305 29.333c-.38 0-.712-.134-.997-.4L14.48 18.928l-2.85 4.802c-.332.623-1.187.8-1.804.49-.665-.312-.855-1.112-.523-1.69l3.277-5.558-6.885-6.937c-.285-.31-.428-.711-.333-1.156.095-.4.428-.756.855-.889l15.147-5.247a1.396 1.396 0 011.472.356c.38.4.428.978.143 1.423L15.856 16.66l10.446 10.583c.523.489.475 1.29-.094 1.778-.238.178-.57.312-.903.312zM9.02 9.724l4.938 5.024L18.943 6.3 9.019 9.724z"/></svg>
</template>

<script>
export default {
  name: 'brandYapay'
}
</script>
